<!--
 * @Author: zl
 * @Date: 2021-09-01 08:37:29
 * @LastEditTime: 2023-05-05 17:20:03
 * @LastEditors: Please set LastEditors
 * @Description: 招投标业务-申请办理 审核页
-->
<template>
	<div class="apply-azc-audit-layout">
		<el-form ref="applyForm" :model="applyForm" label-width="220px" size="small">
			<el-row>
				<el-col :span="24" class="text-center mb30">
					<p class="title">企业申请安招采主体身份-业务办理</p>
				</el-col>
				<el-col :span="24">
					<el-form-item label="申请的企业：">
						{{ rowData.applySub }}
					</el-form-item>
					<el-form-item label="主体身份类型：">
						<el-checkbox-group v-model="applyForm.mainType" disabled>
							<el-checkbox v-for="(x, index) in mainType" :key="'mainType' + index" :label="x.value" disabled>{{
								x.label
							}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="业务要求：">
						<template v-if="dealShow(applyForm.mainType)"> 无 </template>
						<!-- 投标人 支付功能 -->
						<span v-if="applyForm.mainType && applyForm.mainType.includes('1002008003')" class="mr20">
							<svg-icon :icon-class="payFlag ? 'doneImg' : 'selectImg'" :class="payFlag ? 'selectIcon' : 'noselectIcon'"></svg-icon
							>设置企业支付功能
						</span>
						<!-- 招标代理 企业资金账户 -->
						<span v-if="applyForm.mainType && applyForm.mainType.includes('1002008002')">
							<svg-icon
								:icon-class="accountFlag ? 'doneImg' : 'selectImg'"
								:class="accountFlag ? 'selectIcon' : 'noselectIcon'"
							></svg-icon
							>企业绑定对公账户
						</span>
					</el-form-item>
				</el-col>
				<el-col :span="24" class="tips mt15 mb30">
					温馨提示： 1、只选择招标人，无业务要求； 2、只选择投标人，条件必须：支付功能已开通；
					3、只选择投标代理公司，条件必须：企业绑定对公账户； 4、选择招标人，招标代理，条件必须：企业绑定对公账户。
				</el-col>
				<el-col :span="24">
					<el-col :span="12">
						<el-form-item label="申请人姓名：">
							{{ applyForm.applyUser }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作人是否实名：" class="ml1">是</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="申请人证件类型：">
							<!-- {{ dealType(applyForm.cardType) }} -->
							{{ applyForm.cardTypeName }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="申请人证件号：" class="ml1">
							<!-- {{ applyForm.cardNum }} -->
							{{ applyForm.idCard }}
						</el-form-item>
					</el-col>
				</el-col>
				<el-col :span="24">
					<el-form-item label="申请人企业身份：">
						{{ dealSysName(applyForm.isAdmin) }}
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-row>
			<el-col :span="24" class="mt20">
				<p>审核记录：</p>
				<vxe-table
					align="center"
					auto-resize
					border
					class="mt20"
					:data="checkData"
					highlight-current-row
					highlight-hover-row
					show-overflow="tooltip"
					show-header-overflow="tooltip"
				>
					<vxe-table-column field="status" title="审核结果">
						<template #default="{ row }">
							<span v-if="row.status == 1">通过</span>
							<span v-else-if="row.status == 2">驳回</span>
						</template>
					</vxe-table-column>
					<vxe-table-column field="upUserSname" title="审核人"></vxe-table-column>
					<vxe-table-column field="updateDate" title="审核时间"></vxe-table-column>
					<vxe-table-column field="remark" title="备注"></vxe-table-column>
				</vxe-table>
			</el-col>
		</el-row>
		<div class="footer text-center" :class="{ hidden: mode == 'view' }">
			<el-button v-if="isDisabled != 'view'" icon="el-icon-edit-outline" size="mini" @click="auditDialog">审核</el-button>
		</div>
	</div>
</template>
<script>
import * as API from 'api/modules/audit'
import { mapState } from 'vuex'
export default {
	components: {},
	props: {
		companyId: {
			type: String,
			default: ''
		},
		isDisabled: {
			type: String,
			default: ''
		},
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			// 申请企业和申请人信息
			applyForm: {},
			checkData: [], //审核记录
			accountFlag: false, //企业资金账户是否开通
			payFlag: false, //企业支付功能是否开通
			creditCode: '', //社会统一性用码
			mainType: [
				{
					label: '招标人',
					value: '1002008001'
				},
				{
					label: '招标代理',
					value: '1002008002'
				},
				{
					label: '投标人',
					value: '1002008003'
				}
			]
		}
	},
	created() {
		this.companyId != '' ? this.getCompanyMsg() : this.goBack()
	},
	methods: {
		// 查询企业信息
		getCompanyMsg() {
			API.getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.applyForm = this.$utils.clone(res.data, true)
				this.applyForm.mainType = this.applyForm.mainType.split(',')
				if (this.applyForm.status == '2') {
					//判断企业资金账户是否开通
					this.accountFlag = false
					this.payFlag = true
				} else if (this.applyForm.status == '3') {
					this.payFlag = true
					this.accountFlag = true
				} else {
					this.payFlag = false
					this.accountFlag = false
				}
				// 审核记录 -- 2025-09-19 替换以前的单独接口
				this.checkData = res.data.applyRecords || []
			})
		},

		// 审查页返回审计代办页
		goBack() {
			this.$router.push({ path: '/audit-affairs-new' })
		},

		// 审查弹框
		auditDialog() {
			let params = {
				id: this.rowData.id,
				busId: this.rowData.busId
			}
			this.$emit('openDia', params)
		},

		//  判断企业成员身份
		dealSysName(data) {
			let name = ''
			switch (data) {
				case 0:
					name = '企业人员'
					break
				case 1:
					name = '企业主'
					break
				case 2:
					name = '企业管理员'
					break
			}
			return name
		},

		// 处理身份证件类型
		dealType(data) {
			let obj = this.projectDict.smzjlx.find((x) => x.value == data)
			if (obj) {
				return obj.sname
			}
			return ''
		},

		// 展示控制
		dealShow(data) {
			if (data) {
				let num = this.$utils.clone(data, true)
				return num.join(',') == '1002008001'
			}
		}
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		mode() {
			return this.$route.query.mode
		}
	}
}
</script>
<style lang="less" scoped>
.apply-azc-audit-layout {
	padding: 30px 20px;
	height: 100%;
	overflow-y: auto;
	.title {
		font-size: 16px;
		font-weight: 600;
		color: #202020;
	}
	.el-form-item {
		margin-bottom: 0px !important;
		border: 1px solid #dcdcdc;
		margin-top: -1px;
	}
	/deep/ .el-form-item__label,
	/deep/ .el-form-item__content {
		height: 38px;
		line-height: 38px;
	}
	/deep/ .el-form-item__label {
		background-color: #f2f6fc;
		border-right: 1px solid #dcdcdc;
		padding-right: 0px;
		color: #666;
		font-size: 12px;
	}
	/deep/ .el-form-item__content {
		padding-left: 15px;
		font-size: 12px;
	}
	.ml1 {
		margin-left: -1px;
	}
	.footer {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
	.tips {
		font-size: 12px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #2671cc;
	}
	.selectIcon {
		color: #72aa2c;
		margin-right: 5px;
	}
	.noselectIcon {
		color: #ccc;
		margin-right: 5px;
	}
}
</style>
